module.exports = __webpack_public_path__ + "static/media/Agenda8.2099995a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/Agenda/Agenda8.png
// module id = 1972
// module chunks = 0